module.exports = __webpack_public_path__ + "static/media/facebook.8778d9a0.svg";